import Service, { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import { queryManager } from 'ember-apollo-client';
import { task, restartableTask } from 'ember-concurrency';
import currentTillBalanceQuery from 'my-phorest/gql/queries/current-till-balance.graphql';
import { sumMoneyCollection, addMoney } from 'my-phorest/utils/currency';

export const TILL_BALANCE_KEY = 'my-phorest:till-balance';

export default class TillBalanceService extends Service {
  @queryManager apollo;

  @service tillLoader;
  @service('browser/local-storage') localStorage;

  @tracked isOpen = false;
  @tracked balances;
  @tracked integratedPayments;

  constructor() {
    super(...arguments);
    this.reloadBalanceTask.perform();
  }

  get storedIsOpen() {
    let storedValue = this.localStorage.getItem(TILL_BALANCE_KEY);
    return storedValue ? JSON.parse(storedValue) : false;
  }

  updateIsOpen(value) {
    this.isOpen = value;
    this.localStorage.setItem(TILL_BALANCE_KEY, JSON.stringify(value));
  }

  open() {
    this.updateIsOpen(true);
    this.loadBalancesTask.perform();
  }

  close() {
    this.updateIsOpen(false);
  }

  @restartableTask
  *loadBalancesTask() {
    let tillBalanceResponse =
      yield this.loadPaymentMethodBalancesTask.perform();

    this.balances = tillBalanceResponse.balances;
    this.integratedPayments = tillBalanceResponse.integratedPaymentTotals;
  }

  get totalAmount() {
    let balancesTotal = sumMoneyCollection(this.balances, 'expectedAmount');
    let integratedPaymentTotal = sumMoneyCollection(
      this.integratedPayments,
      'amount'
    );

    return addMoney(balancesTotal, integratedPaymentTotal);
  }

  @task
  *loadPaymentMethodBalancesTask() {
    const tillId = yield this.tillLoader.getCurrentTillIdTask.perform();
    const currentTillBalanceResponse = yield this.apollo.query({
      query: currentTillBalanceQuery,
      variables: {
        tillId,
      },
      fetchPolicy: 'network-only',
    });

    return currentTillBalanceResponse.currentTillBalance;
  }

  @task
  *reloadBalanceTask() {
    this.isOpen = this.storedIsOpen;

    if (this.isOpen) {
      yield this.loadBalancesTask.perform();
    }
  }
}
